<template>
  <div class="popular-targets main-space">
    <PopularCities />
  </div>
</template>

<script lang="ts" setup>
import { PopularCities } from '@/features/popularCities';
</script>

<style lang="scss" scoped>
.popular-targets {
  display: flex;
  justify-content: center;

  @include adaptivity.tablet {
    justify-content: stretch;
  }
}
</style>
